import React, { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { Form } from '@kuzmycz/react-form-ula';
import { Button, Loader, Modal, Tab } from '../../../../Components/uielements';
import BioPlusTextField from '../../../../Components/form-fields/BioPlusTextField';
import DropDown from '../../../../Components/uielements/dropDown';
import {
  ModalButtonWrapper,
  OutlineButton,
} from '../../../../services/settings/appStyle/global.style';
import PremiseService from '../../../../services/bioplus-services/premise';
import { PremiseSchema } from '../validator/validator';
import { ModalGap, ModalWrapperTwoColumn } from './modal.styles';
import { getstateList } from '../../CompanyV2/helper/helper';
import { IntlMessages } from '../../../../helper/langHelper';
// import { TabContainer } from '../../UserV2/user.style';
import AssignMasterGeofenceForPremise from './assignMasterGeofenceModal';
import { getCountryCode } from '../../UserInvitation/userInvitation';
import PinDropPremiseMap from './PinDropPremiseMap';

const tabArray = [
  {
    buttonText: 'Edit',
    value: 'edit',
    textId: '1',
  },
  {
    buttonText: 'Master Geofence',
    value: 'master_geofence',
    textId: '2',
  },
];

// Auto-populate the pin from the premise's existing masterCentroid, if any.
const getInitialCentroid = (premise) => {
  const latitude = premise?.masterCentroid?.latitude;
  const longitude = premise?.masterCentroid?.longitude;
  if (
    latitude === undefined ||
    latitude === null ||
    longitude === undefined ||
    longitude === null
  ) {
    return null;
  }
  return { lat: Number(latitude), lng: Number(longitude) };
};

const EditPremiseModal = ({ onClose, premise, userRole, invalidateQuery }) => {
  const [state, setState] = useState();
  const [isProcessing, setIsProcessing] = useState(false);
  const [activeTab, setActiveTab] = useState('edit');
  const [centroid, setCentroid] = useState(() => getInitialCentroid(premise));
  const queryClient = useQueryClient();

  const mutation = useMutation((premise) => PremiseService.update(premise), {
    onSuccess: async () => {
      await queryClient.invalidateQueries(invalidateQuery || 'premises');
      setIsProcessing(false);
      onClose();
    },
    onError: (error) => {
      setIsProcessing(false);
      alert(error);
      onClose();
    },
  });

  const handleSubmit = (values) => {
    const value = {
      ...values,
      ...(state && { addressState: state }),
      ...(centroid && {
        // Same shape/convention as create: strings, later Number()'d where consumed.
        masterCentroid: {
          latitude: String(centroid.lat),
          longitude: String(centroid.lng),
        },
      }),
    };
    setIsProcessing(true);
    mutation.mutate(value);
  };

  const handleTabClick = (clickedTab) => {
    if (clickedTab) {
      setActiveTab(clickedTab);
    }
  };

  const validator = (values) => PremiseSchema.validate(values);
  const stateListBasedOnEnv = getstateList(process.env.REACT_APP_ENV);

  const handleSelectedValue = (value) => {
    setState(value.value);
  };
  const countryPhoneCode = getCountryCode(process.env.REACT_APP_ENV);

  const handleCentroidChange = (nextPosition) => {
    setCentroid(nextPosition);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'edit':
        return (
          <>
            {' '}
            <Form
              initialValues={{
                ...premise,
                contactNumber: premise?.contactNumber || countryPhoneCode,
              }}
              validator={validator}
              onSubmit={handleSubmit}
            >
              <ModalWrapperTwoColumn>
                <ModalGap>
                  <BioPlusTextField
                    label={<IntlMessages id="input.label.name" />}
                    name="propertyName"
                    fullWidth
                  />
                  <IntlMessages id="input.label.propertyId">
                    {(label) => <BioPlusTextField label={label} name="propertyId" fullWidth />}
                  </IntlMessages>
                  <BioPlusTextField
                    label={<IntlMessages id="label.street" />}
                    name="addressStreet"
                    fullWidth
                  />
                  <BioPlusTextField
                    label={<IntlMessages id="label.town" />}
                    name="addressTown"
                    fullWidth
                  />

                  <IntlMessages id="input.label.contact.name">
                    {(label) => <BioPlusTextField label={label} name="contactName" fullWidth />}
                  </IntlMessages>

                  <IntlMessages id="input.label.contact.email">
                    {(label) => <BioPlusTextField label={label} name="contactEmail" fullWidth />}
                  </IntlMessages>

                  <IntlMessages id="input.label.contact.phone">
                    {(label) => <BioPlusTextField label={label} name="contactNumber" fullWidth />}
                  </IntlMessages>
                  <DropDown
                    options={stateListBasedOnEnv}
                    selectedOption={handleSelectedValue}
                    name="addressState"
                    label={<IntlMessages id="label.state" />}
                    placeholder="Select the State"
                    defaultValue={premise.addressState}
                  />
                </ModalGap>

                <PinDropPremiseMap
                  value={centroid}
                  onChange={handleCentroidChange}
                  isEdit={false}
                />

                <ModalButtonWrapper style={{ gridColumn: '1 / -1' }}>
                  <OutlineButton onClick={onClose}>
                    <IntlMessages id="modal.button.cancel" />
                  </OutlineButton>{' '}
                  {isProcessing ? (
                    <Button varient="normal" disabled={isProcessing}>
                      <div style={{ paddingRight: '10px' }}></div>
                      <IntlMessages id="button.text.processing" />
                      <Loader size="small" isNotRequiredLoadingText={true} />
                    </Button>
                  ) : (
                    <Button varient="normal" type="submit">
                      <IntlMessages id="modal.button.submit" />
                    </Button>
                  )}
                </ModalButtonWrapper>
              </ModalWrapperTwoColumn>
            </Form>
          </>
        );
      case 'master_geofence':
        return (
          <>
            <AssignMasterGeofenceForPremise onClose={onClose} premise={premise} />
          </>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Modal
        isOpen={true}
        // onClose={onClose}
        title={<IntlMessages id="modal.title.edit" />}
        // isHeader={userRole !== 'owner' ? true : false}
      >
        {/* {userRole === 'owner' && (
          <TabContainer>
            <Tab buttonArray={tabArray} onButtonClick={handleTabClick} activeTab={activeTab} />
          </TabContainer>
        )} */}
        {renderTabContent()}
      </Modal>
    </>
  );
};

export default EditPremiseModal;
